import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { formSubmissionAlert } from '../alerts/Alerts';

function Sidebar({ caseId, renewalCase }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [adminSession, setAdminSession] = useState(sessionStorage.getItem('adminSession'));
  const isActiveLink = (path) => location.pathname === path;

  


  const handleLinkClick = (event, path, isSummary) => {
    if (isSummary) {
      
      if (renewalCase?.caseType === 'COBRA' && renewalCase?.cobraSubmissionStatus !== 'Submitted') {
        event.preventDefault(); 
        formSubmissionAlert();
      }
      else if (renewalCase?.caseType !== 'COBRA' && renewalCase?.ebSubmissionStatus !== 'Submitted') {
        event.preventDefault(); 
        formSubmissionAlert();
      }
    }
  };

  return (
    <nav className="navbar navbar-inverse fixed-top" id="sidebar-wrapper" role="navigation">
      <button type="button" className="hamburger animated fadeInLeft is-open" data-toggle="offcanvas">
        <i className="hamb-right-arrow fas fa-angle-right"></i>
        <span className="hamb-top"></span>
        <span className="hamb-middle"></span>
        <span className="hamb-bottom"></span>
        <i className="hamb-left-arrow fas fa-angle-left"></i>
      </button>
      <ul className="nav sidebar-nav">
        <li className='mb-2'>
          <span id="overall-status" className="badge bg-warning rounded-0 progress-status">
            {renewalCase?.caseStatus}
          </span>
        </li>
        <li>
         {adminSession === 'active' ?(
          <Link 
          to="/Admin" 
          className={`sidebar-components ms-3 dashboard-link ${isActiveLink('/') ? 'active' : ''}`}
        >
          Admin Dashboard
        </Link>
         ):(
          <Link 
            to="/Dashboard" 
            className={`sidebar-components ms-3 dashboard-link ${isActiveLink('/') ? 'active' : ''}`}
          >
            Dashboard
          </Link>
         )} 
          
        </li>

        {renewalCase?.caseType === 'COBRA' ? (
          <>
            <li id="cobra-menu">
              <Link 
                to={`/Cobra/${caseId}`} 
                className={`sidebar-components ms-3 ${isActiveLink(`/Cobra/${caseId}`) ? 'active' : ''}`}
                id="cobra-info-link"
              >
                COBRA
              </Link>
            </li>
            <li>
              <Link 
                to={`/CobraSummary/${caseId}`} 
                className={`sidebar-components ms-3 ${isActiveLink(`/CobraSummary/${caseId}`) ? 'active' : ''}`}
                id="summary-info-link"
                onClick={(e) => handleLinkClick(e, `/CobraSummary/${caseId}`, true)} // Prevent navigation if not submitted
              >
                Summary
              </Link>
            </li>
          </>
        ) : (
          <>
            <li id="cobra-menu">
              <Link 
                to={`/EmployeeBenefits/${caseId}`} 
                className={`sidebar-components ms-3 ${isActiveLink(`/EmployeeBenefits/${caseId}`) ? 'active' : ''}`}
                id="cobra-info-link"
              >
                Employee Benefits
              </Link>
            </li>
            <li>
              <Link 
                to={`/FileUpload/${caseId}`} 
                className={`sidebar-components ms-3 ${isActiveLink(`/FileUpload/${caseId}`) ? 'active' : ''}`}
              >
                File Upload
              </Link>
            </li>
            <li>
              <Link 
                to={`/EmployeeBenefitsSummary/${caseId}`} 
                className={`sidebar-components ms-3 ${isActiveLink(`/EmployeeBenefitsSummary/${caseId}`) ? 'active' : ''}`}
                id="summary-info-link"
                onClick={(e) => handleLinkClick(e, `/EmployeeBenefitsSummary/${caseId}`, true)} // Prevent navigation if not submitted
              >
                Summary
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Sidebar;
